import { FC, useContext, useEffect } from "react";

import { UserContext } from "@/components/User/UserContext";
import { refresh, setConsultantProfileId } from "@/data/session";
import { SessionContext } from "@/infrastructure/Session";

interface ConsultantProfileIdObserverProps {}

export const ConsultantProfileIdObserver: FC<ConsultantProfileIdObserverProps> = ({}) => {
  const { update } = useContext(SessionContext);
  const { contextConsultantProfileId } = useContext(UserContext);

  useEffect(() => {
    const refreshToken = async () => {
      setConsultantProfileId(contextConsultantProfileId);

      const user = await refresh();
      update(user);
    };

    refreshToken();
  }, [contextConsultantProfileId, update]);

  return null;
};
